import type React from 'react'

import { Inlet } from './Inlet'
import type { RenderOptions } from './renderApp'
import { renderApp } from './renderApp'

declare const WEBPACK_INLET_VERSION: string

interface BootstrapConfig<T> {
  appName: string
  AppComponent: React.ComponentType
  options?: RenderOptions<T>
}

/**
 * Bootstraps a React application using the provided configuration.
 *
 * @template T - The type of the dynamic configuration params.
 * @param config - The configuration object for bootstrapping the app.
 * @param config.appName - The name of the application to initialize with the Inlet instance.
 * @param config.AppComponent - The root React component to render.
 * @param config.options - Additional rendering options for the application See {@link RenderOptions}.
 * @returns The result of rendering the application, as returned by `renderApp`.
 */
export function bootstrap<T>(config: BootstrapConfig<T>) {
  const inletInstance = new Inlet(config.appName, WEBPACK_INLET_VERSION)

  return renderApp(inletInstance, config.AppComponent, config.options)
}
